<template>
  <div class="animated fadeIn form-abm">
    <b-row>
      <b-col xl="12">
        <b-card header= "Información del Proveedor">
          <b-form>
            <b-form-group
              label="Razón Social"
              label-for="razonSocial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="razonSocial"
                v-model.trim="$v.razonSocial.$model" 
                :state="razonSocialValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="razonSocialFeedback">
                {{ razonSocialInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nombre Comercial"
              label-for="nombreComercial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombreComercial"
                v-model.trim="$v.nombreComercial.$model" 
                :state="nombreComercialValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreComercialFeedback">
                {{ nombreComercialInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-condicion-fiscal
              label="Cond.Fiscal"
              :nombre="condicionFiscalNombre"
              :label-cols="labelCols"
              :valido="condicionFiscalValida"
              :lista="condicionesFiscalesList"
              :msjInvalido="condicionFiscalInvalidaMsj"
              @validate="validate"
              @updated="condicionFiscalActualizada">
            </app-condicion-fiscal>  

            <app-documento-tipo
              label="Tipo Identificación"
              :nombre="documentoTipoNombre"
              :lista="documentosTiposList"
              :valido="documentoTipoValido"
              :msjInvalido="documentoTipoInvalidoMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="documentoTipoActualizado">
            </app-documento-tipo>  

            <b-form-group
              label="Cód. Identificación"
              label-for="documentoNumero"
              :label-cols="labelCols"
              description="Código de identificación tributaria (CUIT, RUT, CIF, TIN\EIN, etc)"
              horizontal>
              <b-form-input 
                id="documentoNumero"
                v-model.trim="$v.documentoNumero.$model" 
                :state="documentoNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="documentoNumeroFeedback">
                {{ documentoNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <!-- <b-form-group
              label="CUIT"
              label-for="cuit"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cuit"
                v-model.trim= "$v.cuit.$model" 
                :state="cuitValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cuitFeedback">
                {{ cuitInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group> -->

            <b-form-group
              label="Dirección"
              label-for="direccion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="direccion"
                v-model.trim="$v.direccion.$model" 
                :state="direccionValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="direccionFeedback">
                {{ direccionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-pais
              label="Pais"
              :nombre="paisNombre"
              :lista="paisesList"
              :labelCols="labelCols"
              :nullDisabled="false"
              @updated="paisActualizado">
            </app-pais>  

            <app-provincia
              label="Provincia"
              :nombre="provinciaNombre"
              :lista="provinciasList"
              :labelCols="labelCols"
              :nullDisabled="false"
              @updated="provinciaActualizada">
            </app-provincia>

            <app-localidad
              label="Localidad"
              :nombre="localidadNombre"
              :lista="localidadesList"
              :labelCols="labelCols"
              :nullDisabled="false"
              @updated="localidadActualizada">
            </app-localidad>  

            <b-form-group
              label="Teléfono"
              label-for="telefono"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="telefono"
                v-model.trim="$v.telefono.$model" 
                :state="telefonoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="telefonoFeedback">
                {{ telefonoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Celular"
              label-for="celular"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="celular"
                v-model.trim="$v.celular.$model" 
                :state="celularValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="celularFeedback">
                {{ celularInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Email"
              label-for="email"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="email"
                v-model.trim="$v.email.$model" 
                :state="emailValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="emailFeedback">
                {{ emailInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Email"
              label-for="email2"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="email2"
                v-model.trim="$v.email2.$model" 
                :state="email2Valido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="email2Feedback">
                {{ email2InvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-pais
              label="Banco"
              :nombre="bancoNombre"
              :lista="bancosList"
              :valido="bancoValido"
              :msjInvalido="bancoInvalidoMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="bancoActualizado">
            </app-pais>  

            <b-form-group
              label="Nro.Cuenta"
              label-for="bancoCuentaNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="bancoCuentaNumero"
                v-model.trim="$v.bancoCuentaNumero.$model" 
                :state="bancoCuentaNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="bancoCuentaNumeroFeedback">
                {{ bancoCuentaNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="CBU"
              label-for="cbu"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cbu"
                v-model.trim="$v.cbu.$model" 
                :state="cbuValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cbuFeedback">
                {{ cbuInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="CBU Alias"
              label-for="cbuAlias"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cbuAlias"
                v-model.trim="$v.cbuAlias.$model" 
                :state="cbuAliasValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cbuAliasFeedback">
                {{ cbuAliasInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-cuenta
              label="Cuenta"
              :nombre="cuentaNombre"
              :lista="cuentasList"
              :labelCols="labelCols"
              :nullDisabled="false"
              @updated="cuentaActualizada">
            </app-cuenta>

            <app-rubro
              label="Rubro"
              :nombre="rubroNombre"
              :lista="rubrosList"
              :labelCols="labelCols"
              :nullDisabled="false"
              :valido="rubroValido"
              :msjInvalido="rubroInvalidoMsj"
              @updated="rubroActualizado">
            </app-rubro>

            <app-subrubro
              label="Subrubro"
              :nombre="subrubroNombre"
              :lista="subrubrosList"
              :labelCols="labelCols"
              :nullDisabled="false"
              :valido="subrubroValido"
              :msjInvalido="subrubroInvalidoMsj"
              @updated="subrubroActualizado">
            </app-subrubro>  

            <app-forma-pago
              label="Forma de Pago"
              :nombre="formaPagoNombre"
              :lista="formasPagoList"
              :labelCols="labelCols"
              :nullDisabled="false"
              :valido="formaPagoValida"
              :msjInvalido="formaPagoInvalidaMsj"
              @updated="formaPagoActualizada">
            </app-forma-pago>

            <b-form-group
              label="Plazo"
              label-for="formaPagoPlazo"
              :label-cols="labelCols"
              description="Plazo de pago (sólo ingresar números)"
              horizontal>
              <b-form-input 
                id="formaPagoPlazo"
                v-model.trim="$v.formaPagoPlazo.$model" 
                :state="formaPagoPlazoValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="formaPagoPlazoFeedback">
                {{ formaPagoPlazoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Observaciones"
              label-for="formaPagoObservaciones"
              :label-cols="labelCols"
              description="Observaciones sobre la forma de pago"
              horizontal>
              <b-form-textarea
                id="formaPagoObservaciones"
                v-model="$v.formaPagoObservaciones.$model" 
                rows="3"
                max-rows="5"
                :state="formaPagoObservacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="formaPagoObservacionesFeedback">
                {{ formaPagoObservacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="transporte"
                  v-model="transporte"
                  value= true
                  unchecked-value= false>
                  Es Transporte
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="noRequiereContrato"
                  v-model="noRequiereContrato"
                  value= true
                  unchecked-value= false>
                  No Requiere Contrato
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              v-if="tieneContratoVisible"
              horizontal>
              <b-form-checkbox 
                  id="tieneContrato"
                  v-model="tieneContrato"
                  value= true
                  unchecked-value= false>
                  Tiene Contrato Firmado
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              v-if="tieneContratoVisible & contratoPagareVisible"
              horizontal>
              <b-form-checkbox 
                  id="contratoPagare"
                  v-model="contratoPagare"
                  value= true
                  unchecked-value= false>
                  Contrato con Pagaré
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              v-if="optionIndicarPlazos"
              horizontal>
              <b-form-checkbox 
                  id="excluidoIndicadorPlazos"
                  v-model="excluidoIndicadorPlazos"
                  value= true
                  unchecked-value= false>
                  Excluido del Indicador de Plazos de Pago
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="eventual"
                  v-model="eventual"
                  value= true
                  unchecked-value= false>
                  Excluido del Ranking de Proveedores
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="noEvaluar"
                  v-model="noEvaluar"
                  value= true
                  unchecked-value= false>
                  No Evaluar
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
                  Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import CondicionFiscal from '../shared/abmSelect.vue';
import DocumentoTipo from '../shared/abmSelect.vue';
import Pais from '../shared/abmSelect.vue';
import Provincia from '../shared/abmSelect.vue';
import Localidad from '../shared/abmSelect.vue';
import Banco from '../shared/abmSelect.vue';
import Cuenta from '../shared/abmSelect.vue';
import Rubro from '../shared/abmSelect.vue';
import Subrubro from '../shared/abmSelect.vue';
import FormaPago from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, requiredIf, numeric, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'proveedor/getField',
  mutationType: 'proveedor/updateField',
});

const CBU = ((value, vm) => {
  /* Validamos CBU solo si el banco es argentino */
  if (value == '' || vm.bancoPaisId != 1) {
    return true;
  } else {
    if (!isNaN(parseInt(value))) {
      if ((value.length == 1 && parseInt(value) == 0) || value.length == 22) {
        return true;
      }
    }
  }

  return false;
})

const DocumentoValido = ((value, vm) => {
  if (value == '') {
    return true;
  } else {

    let isValid = true;
    switch (vm.documentoTipoId) {
      case 2:
        /* Cuit (11 digitos numéricos) */
        if (isNaN(parseInt(value))) {
          isValid = false;
        } else {
          let length = Math.log(value) * Math.LOG10E + 1 | 0;  
          if (length != 0 & length != 11) {
            isValid = false;
          }
        }
        break;
    }
    return isValid;
  }
})

export default {
  name: 'ProveedorABM',
  components: {
    appCondicionFiscal: CondicionFiscal,
    appDocumentoTipo: DocumentoTipo,
    appPais: Pais,
    appProvincia: Provincia,
    appLocalidad: Localidad,
    appBanco: Banco,
    appCuenta: Cuenta,
    appRubro: Rubro,
    appSubrubro: Subrubro,
    appFormaPago: FormaPago,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,
      loadingPaises: false,
      loadingProvincias: false,
      loadingCuentas: false,

      noValidar: true,
      nombreComercialValido: null,
      nombreComercialInvalidoMsj: '',
      razonSocialValida: null,
      razonSocialInvalidaMsj: '',
      condicionFiscalValida: null,
      condicionFiscalInvalidaMsj: '',
      documentoTipoValido: null,
      documentoTipoInvalidoMsj: '',
      documentoNumeroValido: null,
      documentoNumeroInvalidoMsj: '',
      // cuitValido: null,
      // cuitInvalidoMsj: '',
      direccionValida: null,
      direccionInvalidaMsj: '',
      telefonoValido: null,
      telefonoInvalidoMsj: '',
      celularValido: null,
      celularInvalidoMsj: '',
      emailValido: null,
      emailInvalidoMsj: '',
      email2Valido: null,
      email2InvalidoMsj: '',
      bancoValido: null,
      bancoInvalidoMsj: '',
      bancoCuentaNumeroValido: null,
      bancoCuentaNumeroInvalidoMsj: '',
      cbuValido: null,
      cbuInvalidoMsj: '',
      cbuAliasValido: null,
      cbuAliasInvalidoMsj: '',
      cuentaValida: null,
      cuentaInvalidaMsj: '',
      rubroValido: null,
      rubroInvalidoMsj: '',
      subrubroValido: null,
      subrubroInvalidoMsj: '',
      formaPagoValida: null,
      formaPagoInvalidaMsj: '',
      formaPagoPlazoValido: null,
      formaPagoPlazoInvalidoMsj: '',
      formaPagoObservacionesValidas: null,
      formaPagoObservacionesInvalidasMsj: '',

      localidades: [],
      localidadesList: [],
      provincias: [],
      provinciasList: [],
      paises: [],
      paisesList: [],
      condicionesFiscales: [],
      condicionesFiscalesList: [],
      documentosTipos: [],
      documentosTiposList: [],
      bancos: [],
      bancosList: [],
      cuentas: [],
      cuentasList: [],
      rubros: [],
      rubrosList: [],
      subrubros: [],
      subrubrosList: [],
      formasPago: [],
      formasPagoList: [],

      labelCols: 2,
      optionIndicarPlazos: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombreComercial',
      'razonSocial',
      'condicionFiscal',
      'documentoTipoId',
      'documentoTipo',
      'documentoTipoNombre',
      'documentoNumero',
      // 'cuit',
      'direccion',
      'pais',
      'provincia',
      'localidad',
      'telefono',
      'celular',
      'email',
      'email2',
      'transporte',
      'tieneContrato',
      'contratoPagare',
      'noRequiereContrato',
      'excluidoIndicadorPlazos',
      'eventual',
      'noEvaluar',
      'inactivo',
      'paisNombre',
      'provinciaNombre',
      'localidadNombre',
      'condicionFiscalNombre',
      'banco',
      'bancoNombre',
      'bancoCuentaNumero',
      'cbu',
      'cbuAlias',
      'cuenta',
      'cuentaNombre',
      'rubro',
      'rubroNombre',
      'subrubro',
      'subrubroNombre',
      'formaPago',
      'formaPagoNombre',
      'formaPagoPlazo',
      'formaPagoObservaciones',

      'bancoPaisId'
    ]),
    tieneContratoVisible() {
      let isVisible = true;
      if ((/true/i).test(this.noRequiereContrato)) {
        isVisible = false;
      }
      return isVisible;
    },
    contratoPagareVisible() {
      let isVisible = false;
      if ((/true/i).test(this.tieneContrato)) {
        isVisible = true;
      }
      return isVisible;
    }
  },  
  created() {
    let proveedorId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        proveedorId = this.$route.params.id;
      }
    }

    this.loadingPaises = true;
    this.loadingProvincias = true;
    this.loadingCuentas = true;

    /* Acceso a editar la condicion de excluido del indicador */
    let userRolId = parseInt(this.$store.getters['user/rolId']);
    switch (userRolId) {
      case 1:
      case 2:
      case 6:
      case 7:
      case 8:
      case 21: /* Responsable de Finanzas y Proveedores */
      case 22: /* Responsable de Facturacion e Impuestos */
      case 23: /* Asistente de Calidad */
        this.optionIndicarPlazos = true;
        break;
    }

    let params= {
      proveedorId
    }

    this.showSpinner();
    this.$store.dispatch('proveedor/inicializar', params)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => {
        this.loadingCuentas = false;
        this.hideSpinner();
      })
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this

      this.$store.dispatch('paises/getPaisesSelect')
        .then(() => {
          vm.paises = this.$store.getters['paises/paisesSelect'];
          vm.paisesList = this.$store.getters['paises/listSelect'];
          vm.loadingPaises = false;
          return;
        })
        .then(() => this.getProvincias())
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de paises.'));        

      this.$store.dispatch('condicionesfiscales/getCondicionesFiscales')
        .then(() => {
          vm.condicionesFiscales = this.$store.getters['condicionesfiscales/list']
          vm.condicionesFiscalesList = this.$store.getters['condicionesfiscales/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de condiciones fiscales.'));                

      this.$store.dispatch('documentostipos/getList')
        .then(() => {
          vm.documentosTipos = this.$store.getters['documentostipos/list']
          vm.documentosTiposList = this.$store.getters['documentostipos/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de tipos de identificación.'));

      this.$store.dispatch('bancos/getBancosList')
        .then(() => {
          vm.bancos = this.$store.getters['bancos/bancosList']
          vm.bancosList = this.$store.getters['bancos/bancosSelectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de bancos.'));
      
      this.cuentas = [];
      this.cuentasList = [];
      this.$store.dispatch('cuentas/getList')
        .then(() => {
          this.cuentas = this.$store.getters['cuentas/list']
          this.cuentasList = this.$store.getters['cuentas/selectList']
          return;
        })
        .then (() => {
          this.getRubros(false);
          return;
        })
        .then (() => {
          this.getSubrubros(false);
          return;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de cuentas.'));

      this.$store.dispatch('formaspago/getList')
        .then(() => {
          vm.formasPago = this.$store.getters['formaspago/list']
          vm.formasPagoList = this.$store.getters['formaspago/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de formas de pago.'));
    },

    getProvincias() {
      this.provincias = [];
      this.provinciasList = [];

      if (this.paisNombre)
      {
        let pais = this.getSelected(this.paises, this.paisNombre);
        if (pais)
        {
          this.$store.dispatch('provincias/getList', pais.id)
            .then(() => {
              this.provincias = this.$store.getters['provincias/list']
              this.provinciasList = this.$store.getters['provincias/selectList']
              this.loadingProvincias = false;
            })
            .then (() => this.getLocalidades())
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de provincias.'));
        }
      }
    },
    getLocalidades() {
      this.localidades = [];
      this.localidadesList = [];

      if (this.provinciaNombre)
      {
        let provincia = this.getSelected(this.provincias, this.provinciaNombre);
        if (provincia)
        {
          this.$store.dispatch('localidades/getLocalidadesProvincia', provincia.id)
            .then(() => {
              this.localidades = this.$store.getters['localidades/localidadesProvincia'];
              this.localidadesList = this.$store.getters['localidades/localidadesProvinciaList'];
            })
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de localidades.'));
        }
      }
    },
    getRubros(inicializar) {
      let rubroNombre = this.rubroNombre;
      let subrubroNombre = this.subrubroNombre;
      if (inicializar) {
        rubroNombre = null;
        subrubroNombre = null;
      }

      this.rubrosList = []
      if (this.cuentaNombre) { 
        let cuenta = this.cuentas.find(cuenta => cuenta.nombre.trim() == this.cuentaNombre.trim());
        if (cuenta) {
          cuenta.rubros.forEach(rubro => {
            this.rubrosList.push(rubro.nombre);
          });
        }
      }

      this.rubroNombre = rubroNombre;
    },
    getSubrubros(inicializar) {
      let subrubroNombre = this.subrubroNombre;
      if (inicializar) {
        subrubroNombre = null;
      }

      this.subrubrosList = []
      if (this.cuentaNombre) { 
        let cuenta = this.cuentas.find(cuenta => cuenta.nombre.trim() == this.cuentaNombre.trim());
        if (cuenta) {
          if (this.rubroNombre) {
            let rubro = cuenta.rubros.find(rubro => rubro.nombre.trim() == this.rubroNombre.trim());
            if (rubro) {
              rubro.subrubros.forEach(subrubro => {
                this.subrubrosList.push(subrubro.nombre);
              });
            }
          }
        }
      }
      this.subrubroNombre = subrubroNombre;
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombreComercial' || validarTodos) {
        if (this.$v.nombreComercial.$error) {
          this.nombreComercialValido = false;
          if (!this.$v.nombreComercial.required) {
            this.nombreComercialInvalidoMsj= 'Debe ingresar el nombre comercial.';
          } else if (!this.$v.nombreComercial.maxLength) {
            this.nombreComercialInvalidoMsj = 'El nombre comercial solo puede contener hasta 75 caracteres';
          } 
        } else {
          this.nombreComercialValido = null;
          this.nombreComercialInvalidoMsj = '';
        }
      }
        
      if (campo == 'razonSocial' || validarTodos) {
        if (this.$v.razonSocial.$error) {
          this.razonSocialValida = false;
          if (!this.$v.razonSocial.required) {
            this.razonSocialInvalidaMsj = 'Debe ingresar la razón social.';
          } else if (!this.$v.razonSocial.maxLength) {
            this.razonSocialInvalidaMsj = 'La razón social solo puede contener hasta 75 caracteres';
          }
        } else {
          this.razonSocialValida = null;
          this.razonSocialInvalidaMsj = '';
        }
      }

      if (campo == 'documentoNumero' || validarTodos) {
        if (this.$v.documentoNumero.$error) {
          this.documentoNumeroValido = false;
          if (!this.$v.documentoNumero.required) {
            this.documentoNumeroInvalidoMsj = 'Debe ingresar el código de identificación del proveedor';
          } else if (!this.$v.documentoNumero.DocumentoValido) {
            this.documentoNumeroInvalidoMsj = 'Verifique por favor el código de identificación ingresado';
          } else if (!this.$v.documentoNumero.maxLength) {
            this.documentoNumeroInvalidoMsj = 'El código de identificación solo puede contener hasta 20 caracteres';
          }      
        } else {
          this.documentoNumeroValido = null;
          this.documentoNumeroInvalidoMsj = '';
        }
      }

      // if (campo == 'cuit' || validarTodos) {
      //   if (this.$v.cuit.$error) {
      //     this.cuitValido = false;
      //     if (!this.$v.cuit.required) {
      //       this.cuitInvalidoMsj = 'Debe ingresar el CUIT.';
      //     } else if (!this.$v.cuit.numeric) {
      //       this.cuitInvalidoMsj = 'El CUIT solo puede contener números.';
      //     } else if (!this.$v.cuit.CUIT) {
      //       this.cuitInvalidoMsj = 'Verifique por favor el CUIT ingresado.';
      //     }      
      //   } else {
      //     this.cuitValido = null;
      //     this.cuitInvalidoMsj = '';
      //   }
      // }

      if (campo == 'direccion' || validarTodos) {
        if (this.$v.direccion.$error) {
          this.direccionValida = false;
          if (!this.$v.direccion.maxLength) {
            this.direccionInvalidaMsj = 'La dirección solo puede contener hasta 150 caracteres.';
          }      
        } else {
          this.direccionValida = null;
          this.direccionInvalidaMsj = '';
        }
      }

      if (campo == 'telefono' || validarTodos) {
        if (this.$v.telefono.$error) {
          this.telefonoValido = false;
          if (!this.$v.telefono.maxLength) {
            this.telefonoInvalidoMsj = 'El número de teléfono solo puede contener hasta 50 caracteres.';
          }      
        } else {
          this.telefonoValido = null;
          this.telefonoInvalidoMsj = '';
        }
      }
          
      if (campo == 'celular' || validarTodos) {
        if (this.$v.celular.$error) {
          this.celularValido = false;
          if (!this.$v.celular.maxLength) {
            this.celularInvalidoMsj = 'El número de celular solo puede contener hasta 50 caracteres.';
          }      
        } else {
          this.celularValido = null;
          this.celularInvalidoMsj = '';
        }
      }

      if (campo == 'email' || validarTodos) {
        if (this.$v.email.$error) {
          this.emailValido = false
          if (!this.$v.email.email) {
            this.emailInvalidoMsj = 'El email ingresado no parece ser una dirección de correo válida.';
          } else if (!this.$v.email.maxLength) {
            this.emailInvalidoMsj = 'El email solo puede contener hasta 150 caracteres.';
          }      
        } else {
          this.emailValido = null;
          this.emailInvalidoMsj = '';
        }
      }
          
      if (campo == 'email2' || validarTodos) {
        if (this.$v.email2.$error) {
          this.email2Valido = false;
          if (!this.$v.email2.email) {
            this.email2InvalidoMsj = 'El email ingresado no parece ser una dirección de correo válida.';
          } else if (!this.$v.email2.maxLength) {
            this.email2InvalidoMsj = 'El email solo puede contener hasta 150 caracteres.';
          }      
        } else {
          this.email2Valido = null;
          this.email2InvalidoMsj = '';
        }
      }

      if (campo == 'bancoCuentaNumero' || validarTodos) {
        if (this.$v.bancoCuentaNumero.$error) {
          this.bancoCuentaNumeroValido = false;
          if (!this.$v.bancoCuentaNumero.maxLength) {
            this.bancoCuentaNumeroInvalidoMsj = 'El número de cuenta solo puede contener hasta 20 caracteres.';
          }      
        } else {
          this.bancoCuentaNumeroValido = null;
          this.bancoCuentaNumeroInvalidoMsj = '';
        }
      }

      if (campo == 'cbu' || validarTodos) {
        if (this.$v.cbu.$error) {
          this.cbuValido = false;
          if (!this.$v.cbu.CBU) {
            this.cbuInvalidoMsj = 'Verifique por favor el CBU ingresado.';
          }      
        } else {
          this.cbuValido = null;
          this.cbuInvalidoMsj = '';
        }
      }

      if (campo == 'cbuAlias' || validarTodos) {
        if (this.$v.cbuAlias.$error) {
          this.cbuAliasValido = false;
          if (!this.$v.cbuAlias.maxLength) {
            this.cbuAliasInvalidoMsj = 'El alias de CBU solo puede contener hasta 50 caracteres.';
          }      
        } else {
          this.cbuAliasValido = null;
          this.cbuAliasInvalidoMsj = '';
        }
      }

      if (campo == 'formaPagoPlazo' || validarTodos) {
        if (this.$v.formaPagoPlazo.$error) {
          this.formaPagoPlazoValido = false;
          if (!this.$v.formaPagoPlazo.numeric) {
            this.formaPagoPlazoInvalidoMsj = 'El plazo de pago ingresado no es válido.';
          }
        } else {
          this.formaPagoPlazoValido = null;
          this.formaPagoPlazoInvalidoMsj = '';
        }
      }

      if (campo == 'formaPagoObservaciones' || validarTodos) {
        if (this.$v.formaPagoObservaciones.$error) {
          this.formaPagoObservacionesValidas = false;
          if (!this.$v.formaPagoObservaciones.maxLength) {
            this.formaPagoObservacionesInvalidasMsj = 'Las observaciones correspondientes a la forma de pago solo puede contener hasta 500 caracteres.';
          }      
        } else {
          this.formaPagoObservacionesValidas = null;
          this.formaPagoObservacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (!this.objetoValido('pais', this.paisNombre, this.paises, 
          'setPais', true, this.paisValido, this.paisInvalidoMsj, 
          'Debe seleccionar el pais correspondiente.')) {
          save = false;
      }

      if (!this.objetoValido('provincia', this.provinciaNombre, this.provincias, 
        'setProvincia', true, this.provinciaValida, this.provinciaInvalidaMsj, 
        'Debe seleccionar la provincia correspondiente.')) {
          save = false;
      }

      if (!this.objetoValido('localidad', this.localidadNombre, this.localidades, 
        'setLocalidad', false, null, null, '')) {
          save = false;
      }

      if (!this.objetoValido('condicionFiscal', this.condicionFiscalNombre, this.condicionesFiscales, 
        'setCondicionFiscal', true, this.condicionFiscalValida, this.condicionFiscalInvalidaMsj, 
        'Debe seleccionar la condición fiscal.')) {
          save = false;
      }

      if (!this.objetoValido('documentoTipo', this.documentoTipoNombre, this.documentosTipos, 
        'setDocumentoTipo', true, this.documentoTipoValido, this.documentoTipoInvalidoMsj, 
        'Debe seleccionar el tipo de identificación.')) {
          save = false;
      }

      if (!this.objetoValido('banco', this.bancoNombre, this.bancos, 
        'setBanco', false, null, null, '')) {
          save = false;
      }

      let cuenta;
      let rubro;
      let subrubro;

      if (this.cuentaNombre) {
        cuenta = this.cuentas.find(cuenta => cuenta.nombre.trim() == this.cuentaNombre.trim());
      }
      if (cuenta && this.rubroNombre) {
          rubro = cuenta.rubros.find(rubro => rubro.nombre.trim() == this.rubroNombre.trim());
          if (rubro && this.subrubroNombre)  {
            subrubro = rubro.subrubros.find(subrubro => subrubro.nombre.trim() == this.subrubroNombre.trim());
          }
      }

      this.$store.dispatch('proveedor/setCuenta', cuenta);
      this.$store.dispatch('proveedor/setRubro', rubro);
      this.$store.dispatch('proveedor/setSubrubro', subrubro);

      if (cuenta && !rubro) {
        if (cuenta.rubros) {
          if (cuenta.rubros.length != 0) {
            this.rubroValido = false;
            this.rubroInvalidoMsj = "Debe seleccionar un rubro";
            save = false;
          }
        }
      }
      if (rubro && !subrubro) {
        if (rubro.subrubros) {
          if (rubro.subrubros.length != 0) {
            this.subrubroValido = false;
            this.subrubroInvalidoMsj = "Debe seleccionar un subrubro";
            save = false;
          }
        }
      }

      if (!this.objetoValido('formaPago', this.formaPagoNombre, this.formasPago, 
        'setFormaPago', false, null, null, '')) {
          save = false;
      }

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('proveedor/save')
            .then(()  => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        } 
      }
    },
    objetoValido(objeto, objetoNombre, objetoList, objetoDispatch, validar, 
        objetoValido, objetoInvalidoField, objetoInvalidoMsj) {
      let isValido = true;
      let selected = null;
      if (objetoNombre) {
        selected = this.getSelected(objetoList, objetoNombre);
      }
      this.$store.dispatch('proveedor/' + objetoDispatch, selected);

      let objetoStore = this.$store.getters['proveedor/' + objeto];

      if (validar) {
        if (objetoStore) {
          if (objetoStore.id) {
            if (objetoStore.id != 0) {
              isValido = false;
            }
          }
        }
        if (!isValido) {
          objetoValido = false;
          objetoInvalidoField = objetoInvalidoMsj;
        }
      }
      return isValido;
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.push({ name: "Proveedores" });
    },
    paisActualizado(paisNombre) {
      if (!this.loadingPaises) {
        this.paisNombre = paisNombre;

        this.provinciaNombre = null;
        this.localidadNombre = null;
        this.getProvincias();
        this.getLocalidades();

        this.paisValido = null;
        this.paisInvalidoMsj = '';
      }
    },
    provinciaActualizada(provinciaNombre) {
      if (!this.loadingProvincias) {
        this.provinciaNombre = provinciaNombre;
        this.localidadNombre = null;
        this.getLocalidades();

        this.provinciaValida = null;
        this.provinciaInvalidaMsj = '';
      }
    },
    localidadActualizada(localidadNombre) {
      this.localidadNombre = localidadNombre;
    },
    condicionFiscalActualizada(condicionFiscalNombre) {
      if ( condicionFiscalNombre ) {
        this.condicionFiscalNombre = condicionFiscalNombre;
        this.condicionFiscalValida = null;
        this.condicionFiscalInvalidaMsj = '';
      }
    },
    documentoTipoActualizado(documentoTipoNombre) {
      this.documentoTipoNombre = documentoTipoNombre;
      if (this.documentoTipoNombre) {
        this.documentoTipoValido = null;
        this.documentoTipoInvalidoMsj = '';
      }
    },
    bancoActualizado(bancoNombre) {
      this.bancoNombre = bancoNombre;
    },
    cuentaActualizada(cuentaNombre) {
      if (!this.loadingCuentas) {
        this.cuentaNombre = cuentaNombre;
        this.cuentaValida = null;
        this.cuentaInvalidaMsj = '';

        this.getRubros(true);
      }
    },
    rubroActualizado(rubroNombre) {
      if (!this.loadingCuentas) {
        this.rubroNombre = rubroNombre;
        this.rubroValido = null;
        this.rubroInvalidoMsj = '';
        this.getSubrubros(true);
      }
    },
    subrubroActualizado(subrubroNombre) {
      if (!this.loadingCuentas) {
        this.subrubroNombre = subrubroNombre;
        this.subrubroValido = null;
        this.subrubroInvalidoMsj = '';
      }
    },
    formaPagoActualizada(formaPagoNombre) {
      if ( formaPagoNombre ) {
        this.formaPagoNombre = formaPagoNombre;
        this.formaPagoValida = null;
        this.formaPagoInvalidaMsj = '';
      }
    },    
  },
  watch: {
    /*
    'provinciaNombre' : function(newVal, oldVal) {
      if ( newVal != oldVal && !this.loadingProvincias) {
        this.localidadNombre = null;
        this.getLocalidades();
      }
    },
    'condicionFiscalNombre': function(newVal, oldVal) {
      if ( newVal != oldVal) {
        if (newVal) {
          this.condicionFiscalValida = null;
          this.condicionFiscalInvalidaMsj = '';
        }
      }
    },
    */
  },
  validations: {
    nombreComercial: {
      required,
      maxLength: maxLength(75)
    },
    razonSocial: {
      required,
      maxLength: maxLength(75)
    },
    documentoNumero: {
      required: requiredIf(function () {
        var isRequired = true;

        if (this.condicionFiscalNombre) {
          var condicionFiscal = this.getSelected(this.condicionesFiscales, this.condicionFiscalNombre);
          if (condicionFiscal) {
            if (condicionFiscal.id == 3) {
              isRequired = false;
            }
          }
        }
        return isRequired;
      }),
      DocumentoValido,
      maxLength: maxLength(20)
    },
    // cuit: {
    //   required: requiredIf(function () {
    //     var isRequired = true;

    //     if (this.condicionFiscalNombre) {
    //       var condicionFiscal = this.getSelected(this.condicionesFiscales, this.condicionFiscalNombre);
    //       if (condicionFiscal) {
    //         if (condicionFiscal.id == 3) {
    //           isRequired = false;
    //         }
    //       }
    //     }

    //     return isRequired;
    //   }),
    //   numeric,
    //   CUIT
    // },
    direccion: {
      maxLength: maxLength(150)
    },
    telefono: {
      maxLength: maxLength(50)
    },
    celular: {
      maxLength: maxLength(50)
    },
    email: {
      email,
      maxLength: maxLength(150)
    },
    email2: {
      email,
      maxLength: maxLength(150)
    },
    bancoCuentaNumero: {
      maxLength: maxLength(20)
    },
    cbu: {
      CBU
    },
    cbuAlias: {
      maxLength: maxLength(50)
    },
    formaPagoPlazo: {
      numeric,
    },
    formaPagoObservaciones: {
      maxLength: maxLength(500)
    },
  },  
}
</script>

<style>
</style>
